"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendPostRequest = exports.requestCampaignToScxBackend = exports.printWaiting = exports.printPrivacyPolicy = exports.printOKVisita = exports.printOKC2C = exports.printKO = exports.printIframe = exports.printBotonCerrar = exports.getCookie = exports.datosUsuarioFromSession = exports.createGetCampaignBody = exports.checkSegment = exports._createSondaContext = exports._ChooseSendOptions = exports._CMNTimeTableValid = exports.TIPOS_ENCAMINAMIENTO = exports.TESVALUES = exports.MODAL_CONTENT = exports.MODALS_TYPES = exports.EMPLEADOS = exports.DESTINO_FORM = exports.DESTINO = void 0;
var _react = _interopRequireDefault(require("react"));
var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));
var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _gerenciatdUnifiedcomponents2 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Variable con los posibles valores del campo empleados
 */
const EMPLEADOS = [{
  value: '2',
  label: 'Hasta 2'
}, {
  value: '10',
  label: '3 o más'
}];

/**
 * Variable con los posibles valores de modales
 */
exports.EMPLEADOS = EMPLEADOS;
const MODALS_TYPES = {
  C2C: 'c2c',
  CALLNOTSTABLISHED: 'callNotStablished',
  CALLPENDING: 'callPending',
  REQUESTPENDING: 'requestPending',
  CMLPENDING: 'cmlPending',
  INVALIDFORM: 'invalidForm'
};

/**
 * Variable con los posibles valores de los destinos del formulario
 */
exports.MODALS_TYPES = MODALS_TYPES;
const DESTINO_FORM = {
  AVATAR: 'AvatarPlus C2C',
  INSIDESALES: 'Inside Sales C2C',
  GEVICO: 'Gevico C2C',
  FONDOS: 'Fondos C2C'
};

/**
 * Variable con los posibles valores de los destinos
 */
exports.DESTINO_FORM = DESTINO_FORM;
const DESTINO = {
  AVATAR: 'Avatar',
  INSIDESALES: 'InsideSales',
  GEVICO: 'Gevico',
  FONDOS: 'Fondos'
};
/**
 * Variable con los posibles valores de encaminamiento
 */
exports.DESTINO = DESTINO;
const TIPOS_ENCAMINAMIENTO = {
  SVC_A: 'SVC_A',
  SVC_B: 'SVC_B',
  SVC_C: 'SVC_C',
  ME_A: 'ME_A',
  ME_B: 'ME_B',
  ME_C: 'ME_C',
  FONINS_A: 'FONINS_A',
  FONINS_B: 'FONINS_B',
  FONINS_C: 'FONINS_C',
  FONINS_D: 'FONINS_D',
  FONINS_E: 'FONINS_E',
  FONGEV_A: 'FONGEV_A',
  FONGEV_B: 'FONGEV_B',
  FONGEV_C: 'FONGEV_C',
  FONGEV_D: 'FONGEV_D',
  FONGEV_E: 'FONGEV_E'
};

/**
 * Variable con los posibles valores de TES
 */
exports.TIPOS_ENCAMINAMIENTO = TIPOS_ENCAMINAMIENTO;
const TESVALUES = {
  SI: 'SI',
  NO: 'NO'
};

/**
 * Especificaciones de mensajes y funcionalidad de los modales
 */
exports.TESVALUES = TESVALUES;
const MODAL_CONTENT = {
  c2c: {
    title_emp: 'Contacta con un experto',
    content_emp: 'Déjanos tus datos y uno de nuestros expertos contactará contigo para resolver dudas o ayudarte con lo que necesites.',
    horario_emp: 'Horario de atención: 9:00-19:00'
  },
  callNotStablished: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Lo sentimos, no hemos podido registrar su solicitud. Inténtelo de nuevo.'
  },
  callPending: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Muchas gracias por su interés, le llamará nuestro próximo agente disponible'
  },
  requestPending: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Espere unos instantes, estamos procesando su solicitud.'
  },
  cmlPending: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Muchas gracias por su interés, le llamaremos en el horario que nos ha indicado.'
  },
  invalidForm: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Rellene los campos correctamente'
  }
};
/**
 * Se crea el objeto de contexto, cuando no se puede acceder desde redux
 * @param {string} segment  segmento
 * @returns {object} Devuelve la informacion de contexto construida
 */
exports.MODAL_CONTENT = MODAL_CONTENT;
const _createSondaContext = segment => {
  let clientIDs = null;
  if (window.IC && window.IC.getClientIds) {
    clientIDs = window.IC.getClientIds();
  }
  const context = {
    pageSegment: segment || '',
    contextURL: window.location.href || '',
    clientIDs
  };
  return context;
};

/**
 * Envia la información del formulario a BI
 * @param {object} data Informacion del formulario
 * @returns {boolean} Devuelve true si no dio error js el envio, false si dio error js
 */
// export const _envioBI = (data, destino, contextEmp) => {
//   const sonda = new Sonda({
//     processName: 'envioBI',
//     context: contextEmp,
//     filePath: 'emp/c2c',
//   });
//   try {
//     const { name, phone, cif, provincia } = data;
//     const iframeForm = document.getElementById('iframeInsideBI');
//     const consDate = Date.now();
//     let campaign = '';
//     try {
//       campaign = SCX.getCurrentInfo().SCX_CAMPAIGN.SCX_CAMPAIGN_VALUE;
//     } catch (error) {
//       sonda.warningMessage({
//         error,
//         info: 'Campaña no fue posible de encontrar en envio BI',
//       });
//       campaign = 'No asignada';
//     }
//     iframeForm.contentWindow.consData.setnSend(
//       name,
//       phone,
//       'C2C@insideSales.com',
//       'N/A',
//       cif,
//       provincia,
//       'N/A',
//       consDate,
//       campaign,
//       destino,
//     );
//     return true;
//   } catch (error) {
//     sonda.errorMessage({ error, info: 'Envio a BI erroneo' });
//     return false;
//   }
// };

/**
 * Comprueba si estamos en horario de atencion valido
 * @returns {boolean} True si estamos dentro de horario, false si no
 */
exports._createSondaContext = _createSondaContext;
const _CMNTimeTableValid = () => {
  try {
    const date = new Date();
    const hour = date.getHours();
    if (hour >= 9 && hour < 19) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

/**
 * Pinta las politicas de privacidad
 * @returns {JSX}
 */
exports._CMNTimeTableValid = _CMNTimeTableValid;
const printPrivacyPolicy = () => {
  {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "modal_wrapper-legal-content",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "Movistar informa que los datos que se facilitan en el presente formulario ser\xE1n tratados por Telef\xF3nica de Espa\xF1a S.A.U. y Telef\xF3nica M\xF3viles Espa\xF1a S.A.U. (en adelante Movistar) como corresponsables con la finalidad de proporcionarle la informaci\xF3n comercial solicitada, as\xED como el resto de finalidades que se hubieran permitido o autorizado de conformidad con lo dispuesto en la <a target=\"_blank\" href=\"/privacidad\">Pol\xEDtica de Privacidad.</a>",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_7,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "Movistar informa que dispondr\xE1 de los siguientes medios para ejercer sus derechos:",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_7,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "\xB7 Si usted ya es Cliente, dirigiendo un escrito Referencia DATOS a la direcci\xF3n de correo electr\xF3nico  <a href=\"mailto:TE_datos@telefonica.com\">TE_datos@telefonica.com</a>; dirigiendo un escrito al Apartado de Correos 46155, 28080 Madrid; o a trav\xE9s del tel\xE9fono gratuito 224407 desde cada una de sus l\xEDneas fijas o m\xF3viles.",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_7,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "\xB7 Si usted no es Cliente Movistar, podr\xE1 ponerse en contacto a trav\xE9s de la siguiente direcci\xF3n de correo electr\xF3nico <a href=\"mailto:arcopcl@telefonica.com\">arcopcl@telefonica.com</a>, o llamando al n\xFAmero 900 10 50 92.",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_7,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      })]
    });
  }
};

/**
 * Pinta el iframe
 * @returns {JSX}
 */
exports.printPrivacyPolicy = printPrivacyPolicy;
const printIframe = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    id: "div_iframe_modal",
    className: "oculto",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
      width: "100%",
      title: "iframeModal",
      id: "iframeInsideModal",
      scrolling: "no",
      src: "https://www.movistar.es/empresas/formulario/modalAtencion"
    })
  });
};

/**
 * Pinta la ventana de ok de c2c
 * @returns {JSX}
 */
exports.printIframe = printIframe;
const printOKC2C = (SvgIconLoader, Modal, taggingInfo) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "wrapper__confirmacion",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", {
      style: {
        height: '100%'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("td", {
          valign: "top",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
            className: "atencionFormulario__modal__icon--left",
            id: "Ok",
            color: "green1",
            kind: "L",
            size: 64,
            segment: "emp"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            text: "Solicitud enviada",
            align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents.SIZE.TITLE45,
            color: _gerenciatdUnifiedcomponents.COLOR.GREY_9,
            fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            text: "En menos de 24 horas uno de nuestros expertos llamar\xE1 al tel\xE9fono de contacto facilitado. Si ya eres cliente lo har\xE1 tu comercial.</br></br>La llamada ser\xE1 realizada en horario L-V de 9 a 18h.</br></br>Muchas gracias por tu inter\xE9s.",
            align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
            color: _gerenciatdUnifiedcomponents.COLOR.GREY_6,
            fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK,
            className: "atencionFormulario__modal__message"
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
          style: {
            'padding-bottom': '10px'
          },
          valign: "bottom",
          children: printBotonCerrar(Modal, taggingInfo)
        })
      })]
    })
  });
};

/**
 * Pinta la ventana de ok de solicita visita
 * @returns {JSX}
 */
exports.printOKC2C = printOKC2C;
const printOKVisita = (SvgIconLoader, Modal, taggingInfo) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "wrapper__confirmacion",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", {
      style: {
        height: '100%'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("td", {
          valign: "top",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
            className: "atencionFormulario__modal__icon--left",
            id: "Ok",
            color: "green1",
            kind: "L",
            size: 64,
            segment: "emp"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            text: "Solicitud enviada",
            align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents.SIZE.TITLE45,
            color: _gerenciatdUnifiedcomponents.COLOR.GREY_9,
            fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            text: "En menos de 24 horas uno de nuestros expertos llamar\xE1 al tel\xE9fono de contacto facilitado para concertar una visita presencial a tu empresa o una videollamada.<br><br>Si ya eres cliente lo har\xE1 tu comercial. La llamada ser\xE1 realizada en horario L-V de 9 a 18h.</br></br>Muchas gracias por tu inter\xE9s.",
            align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
            color: _gerenciatdUnifiedcomponents.COLOR.GREY_6,
            fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK,
            className: "atencionFormulario__modal__message"
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
          style: {
            'padding-bottom': '10px'
          },
          valign: "bottom",
          children: printBotonCerrar(Modal, taggingInfo)
        })
      })]
    })
  });
};

/**
 * Pinta la ventana de ko
 * @returns {JSX}
 */
exports.printOKVisita = printOKVisita;
const printKO = (SvgIconLoader, Modal, taggingInfo) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "wrapper__confirmacion",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", {
      style: {
        height: '100%'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("td", {
          valign: "top",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
            className: "atencionFormulario__modal__icon--left",
            id: "Error",
            color: "red1",
            kind: "L",
            size: 64,
            segment: "emp"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            text: "Solicitud rechazada",
            align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents.SIZE.TITLE45,
            color: _gerenciatdUnifiedcomponents.COLOR.GREY_9,
            fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            text: "Lo sentimos, no hemos podido recibir tu solicitud por alg\xFAn problema t\xE9cnico, int\xE9ntalo m\xE1s tarde.",
            align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
            color: _gerenciatdUnifiedcomponents.COLOR.GREY_6,
            fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK,
            className: "atencionFormulario__modal__message"
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
          style: {
            'padding-bottom': '10px'
          },
          valign: "bottom",
          children: printBotonCerrar(Modal, taggingInfo)
        })
      })]
    })
  });
};

/**
 * Pinta la ventana de waiting
 * @returns {JSX}
 */
exports.printKO = printKO;
const printWaiting = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "placeholderModal",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "placeHolderModal--background"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      version: "1.1",
      id: "L5",
      x: "0px",
      y: "0px",
      viewBox: "0 0 100 100",
      enableBackground: "new 0 0 0 0",
      xmlSpace: "preserve",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        stroke: "none",
        cx: "15",
        cy: "50",
        r: "6",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("animateTransform", {
          attributeName: "transform",
          dur: "1.5s",
          type: "translate",
          values: "0 10 ; 0 -10; 0 10",
          repeatCount: "indefinite",
          begin: "0.1"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        stroke: "none",
        cx: "37.5",
        cy: "50",
        r: "6",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("animateTransform", {
          attributeName: "transform",
          dur: "1.5s",
          type: "translate",
          values: "0 10 ; 0 -10; 0 10",
          repeatCount: "indefinite",
          begin: "0.3"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        stroke: "none",
        cx: "60",
        cy: "50",
        r: "6",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("animateTransform", {
          attributeName: "transform",
          dur: "1.5s",
          type: "translate",
          values: "0 10 ; 0 -10; 0 10",
          repeatCount: "indefinite",
          begin: "0.5"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        stroke: "none",
        cx: "82.5",
        cy: "50",
        r: "6",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("animateTransform", {
          attributeName: "transform",
          dur: "1.5s",
          type: "translate",
          values: "0 10 ; 0 -10; 0 10",
          repeatCount: "indefinite",
          begin: "0.7"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
      text: "Procesando solicitud",
      align: _gerenciatdUnifiedcomponents.ALIGN.CENTER,
      size: _gerenciatdUnifiedcomponents.SIZE.TITLE5,
      color: _gerenciatdUnifiedcomponents.COLOR.BLUE,
      fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
      kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
      segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
      display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
    })]
  });
};

/**
 * Pinta el boton de cerrar
 * @returns {JSX}
 */
exports.printWaiting = printWaiting;
const printBotonCerrar = (Modal, taggingInfo) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
    taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
      componentContent: 'cerrar'
    }),
    borderRadius: _gerenciatdUnifiedcomponents2.BORDER_RADIUS.SM,
    color: _gerenciatdUnifiedcomponents2.BUTTON_COLOR.BLUE,
    size: {
      w: _gerenciatdUnifiedcomponents2.BUTTON_WIDTH.FULL,
      h: _gerenciatdUnifiedcomponents2.BUTTON_HEIGHT.LARGE
    },
    onClick: Modal.hide,
    labelSize: _gerenciatdUnifiedcomponents2.LABEL_SIZE.REGULAR,
    label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
      text: "Cerrar",
      align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
      size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
      color: _gerenciatdUnifiedcomponents.COLOR.WHITE,
      fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
      kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
      segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
      display: _gerenciatdUnifiedcomponents.DISPLAY.INLINE
    }),
    segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP
  });
};

/**
 * Selecciona de forma aleatoria el encaminamiento a seguir de las distintas opciones
 * @returns {object}
 */
exports.printBotonCerrar = printBotonCerrar;
const _ChooseSendOptions = multipleOptions => {
  try {
    const random = Math.random() * 100;
    const keys = Object.keys(multipleOptions);
    const newOptions = {};
    for (let j = 0; j < keys.length; j++) {
      let auxRandom = 0;
      let chooseOption = 0;
      for (let i = 0; i < multipleOptions[keys[j]].encaminamiento.length; i++) {
        if (parseInt(multipleOptions[keys[j]].encaminamiento[i].porcentaje) + auxRandom > random) {
          chooseOption = i;
          break;
        } else {
          auxRandom += parseInt(multipleOptions[keys[j]].encaminamiento[i].porcentaje);
        }
      }
      newOptions[keys[j]] = multipleOptions[keys[j]].encaminamiento[chooseOption];
    }
    return newOptions;
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: '_ChooseSendOptions',
      context: _createSondaContext('empresas'),
      filePath: 'ModalAtencionEmp'
    });
    sonda.errorMessage({
      error,
      info: 'Fallo en seleccion de opciones del modal'
    });
    const keys = Object.keys(multipleOptions);
    const newOptions = {};
    for (let j = 0; j < keys.length; j++) {
      newOptions[keys[j]] = multipleOptions[keys[j]].encaminamiento[0];
    }
    return newOptions;
  }
};
exports._ChooseSendOptions = _ChooseSendOptions;
const datosUsuarioFromSession = () => {
  try {
    const sessionInfo = JSON.parse(sessionStorage.getItem('datosUsuario'));
    return sessionInfo;
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'datosUsuarioFromSession',
      context: _createSondaContext('empresas'),
      filePath: 'ModalAtencionEmp'
    });
    sonda.errorMessage({
      error,
      info: 'Fallo lectura datos usuario de sessionStorage'
    });
    return null;
  }
};
exports.datosUsuarioFromSession = datosUsuarioFromSession;
const sendPostRequest = (url, data, ok_func, ko_func, content_type, timeout) => {
  try {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.async = 1;
    if (timeout == true) {
      xhr.timeout = 3000;
    }
    xhr.setRequestHeader('Content-Type', content_type);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          if (typeof ok_func == 'function') {
            try {
              ok_func(xhr.response);
            } catch (error) {
              const sonda = new _gerenciatdUtils.default({
                processName: 'sendPostRequestSCX',
                context: _createSondaContext('empresas'),
                filePath: 'ModalAtencionEmp'
              });
              sonda.errorMessage({
                error,
                info: 'Fallo en la peticion de campaña de SCX'
              });
            }
          }
        } else if (typeof ko_func == 'function') {
          try {
            ko_func('status: ' + xhr.status + ' - statusText: ' + xhr.statusText + ' ' + xhr.response + ' readyState: ' + xhr.readyState);
          } catch (error) {
            const sonda = new _gerenciatdUtils.default({
              processName: 'sendPostRequestSCX',
              context: _createSondaContext('empresas'),
              filePath: 'ModalAtencionEmp'
            });
            sonda.errorMessage({
              error,
              info: 'Fallo en la peticion de campaña de SCX'
            });
          }
        }
      }
    };
    xhr.ontimeout = function () {
      try {
        ko_func('TimeOut');
      } catch (error) {
        const sonda = new _gerenciatdUtils.default({
          processName: 'sendPostRequestSCX',
          context: _createSondaContext('empresas'),
          filePath: 'ModalAtencionEmp'
        });
        sonda.errorMessage({
          error,
          info: 'Fallo en la peticion de campaña de SCX timeout'
        });
      }
    };
    xhr.send(data);
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'sendPostRequestSCX',
      context: _createSondaContext('empresas'),
      filePath: 'ModalAtencionEmp'
    });
    sonda.errorMessage({
      error,
      info: 'Fallo en la peticion de campaña de SCX'
    });
    ko_func(error);
  }
};
exports.sendPostRequest = sendPostRequest;
const getCookie = cname => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

/* Funcion que comprueba el segmento y lo retorna
 * @return segmento
 */
exports.getCookie = getCookie;
const checkSegment = () => {
  try {
    var cookieNav = null;
    try {
      cookieNav = (void 0).getCookie('SEG_NAV');
    } catch (error) {
      const sonda = new _gerenciatdUtils.default({
        processName: 'checkSegment',
        context: _createSondaContext('empresas'),
        filePath: 'ModalAtencionEmp'
      });
      sonda.errorMessage({
        error,
        info: 'Fallo al obtener el segmento del cliente'
      });
    }
    if (cookieNav) {
      return cookieNav;
    } else {
      if (window.location.href.indexOf('/empresas') >= 0) {
        return 'empresas';
      } else if (window.location.href.indexOf('/particulares') >= 0) {
        return 'particulares';
      }
      //DEFAULT
      return 'particulares';
    }
  } catch (e) {
    return 'particulares';
  }
};

/**
 * Crea la estructura de informacion necesaria para obtener la campaña correspondiente al C2C
 * @returns campaign body
 */
exports.checkSegment = checkSegment;
const createGetCampaignBody = () => {
  try {
    return {
      wbPageId: typeof IC != 'undefined' && typeof IC.getClientIds == 'function' && typeof IC.getClientIds().pageId != 'undefined' ? IC.getClientIds().pageId : 'NO IC',
      uiGaClientID: getCookie('_ga'),
      wbSessionId: getCookie('_mc_sessid'),
      uiMantixCK: getCookie('_mc_uuid'),
      scxFrontVersion: status.version,
      scxFrontHref: window.location.href,
      scxFrontTimestamp: new Date().toISOString(),
      scxFrontInterest1: null,
      scxFrontInterest2: null,
      // solo nutriremos el campo segmento en la home, donde únicamente hay conflicto.
      scxPageSegment: window.location.host == 'www.movistar.es' && window.location.pathname === '/' ? checkSegment() : null,
      experience: null
    };
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'createGetCampaignBody',
      context: _createSondaContext('empresas'),
      filePath: 'ModalAtencionEmp'
    });
    sonda.errorMessage({
      error,
      info: 'Fallo al crear el cuerpo de la peticion para la campaña'
    });
    return null;
  }
};

/**
 * Obtiene la información de campanias del back de SCX y actualiza current_info de forma asíncrona
 * @return retorna una promesa que es resuelta al recibir la respuesta correcta del Backend.
 *
 **/
exports.createGetCampaignBody = createGetCampaignBody;
const requestCampaignToScxBackend = (setCampaign, extraData) => {
  try {
    if (!window.scxValue && window.scxUrlPath !== window.location.pathname) {
      sendPostRequest('https://campaign.scx.col.movistar.es/scx/campaign/dispatcher/campaign', JSON.stringify(createGetCampaignBody()),
      //Caso OK
      function (data) {
        var jsonData = data != '' ? JSON.parse(data) : '';
        window.scxValue = jsonData.scxCampaignValue;
        window.scxUrlPath = window.location.pathname;
        setCampaign(jsonData.scxCampaignValue, extraData);
      },
      //Caso KO --> si se produce error en la propia función sendPostRequest, nos trae el error del catch, lo tratamos.
      function (response) {
        const sonda = new _gerenciatdUtils.default({
          processName: 'requestCampaignToScxBackend',
          context: _createSondaContext('empresas'),
          filePath: 'ModalAtencionEmp'
        });
        sonda.errorMessage({
          info: `Error al obtener la campaña de scx; ${response}`
        });
        window.scxValue = window.location.pathname;
        window.scxUrlPath = window.location.pathname;
        setCampaign(window.localtion.pathname, extraData);
      }, 'text/plain', true);
    } else {
      setCampaign(window.scxValue, extraData);
    }
  } catch (error) {
    const sonda = new _gerenciatdUtils.default({
      processName: 'requestCampaignToScxBackend',
      context: _createSondaContext('empresas'),
      filePath: 'ModalAtencionEmp'
    });
    sonda.errorMessage({
      error,
      info: 'Error al obtener la campaña de scx'
    });
    setCampaign(window.location.pathname, extraData);
  }
};
exports.requestCampaignToScxBackend = requestCampaignToScxBackend;

//# sourceMappingURL=functionsUtils.js.map